import { all, call, Effect, fork, put, takeLatest } from 'redux-saga/effects';
import { ChargePoint } from '../../app/ApiGen';
import { standardiseError } from '../../utils/error';
import { Normalised } from '../../utils/request';
import { getCurrentChargePointAction, setChargePointErrorAction, setCurrentChargePointAction } from './actions';
import { getChargePoint } from './api';

export function* handleGetCurrentChargePoint(
  action: ReturnType<typeof getCurrentChargePointAction>,
): Generator<Effect> {
  try {
    const chargePoint = (yield call(getChargePoint, action.payload.selectedItemId)) as Normalised<ChargePoint>;
    yield put(setCurrentChargePointAction({ chargePoint }));
  } catch (e) {
    const error = standardiseError(e);
    yield put(setChargePointErrorAction({ error, selectedItemId: action.payload.selectedItemId }));
  }
}

function* watchGetCurrentChargePoint() {
  yield takeLatest(getCurrentChargePointAction, handleGetCurrentChargePoint);
}

export function* chargePointSagas(): Generator<Effect> {
  yield all([fork(watchGetCurrentChargePoint)]);
}
